import React from 'react';

import { ToastContainer } from 'react-toastify';
import Router from './Router.tsx';

import { Persister, PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { MsalProvider } from '@azure/msal-react';
import { QueryClient } from '@tanstack/react-query';

import { broadcastQueryClient } from '@tanstack/query-broadcast-client-experimental';
import { PublicClientApplication } from '@azure/msal-browser';

const persister: Persister = createSyncStoragePersister({
  storage: window.sessionStorage,
});

const queryClient = new QueryClient();

broadcastQueryClient({
  queryClient,
  broadcastChannel: 'oresundpay-tollling-admin',
});

interface AppProps {
  msalInstance: PublicClientApplication;
}

function App({ msalInstance }: AppProps) {
  return (
    <React.StrictMode>
      <PersistQueryClientProvider client={queryClient} persistOptions={{ persister }}>
        <MsalProvider instance={msalInstance}>
          <Router />
          <ToastContainer />
        </MsalProvider>
      </PersistQueryClientProvider>
    </React.StrictMode>
  );
}

export default App;
